import { createFileRoute } from "@tanstack/react-router";
import { Card, PageHeading } from "@/ui";
import { muted } from "@/components/shared/styles";
import { EmailApprovalWebhookForm } from "#/components/settings/EmailApprovalWebhookForm";

// Developer > Webhook. The email-approval webhook, on the route that names it.
//
// It used to share Developer settings with a table contrasting transactional
// and publication sends — product copy inside a settings surface, deleted
// rather than relocated by the sidebar IA reorg.
export const Route = createFileRoute("/dashboard/w/$workspaceId/developer/webhook")({
  component: WebhookPage,
});

function WebhookPage() {
  const { workspaceId } = Route.useParams();

  return (
    <div className="flex max-w-3xl flex-col gap-6">
      <PageHeading
        title="Webhook"
        lede="Where we call your app after a send request is approved or rejected."
      />

      <Card
        title="Email approval webhook"
        action={
          <span className="text-xs" style={muted}>
            fires after a send request is resolved
          </span>
        }
      >
        <EmailApprovalWebhookForm workspaceId={workspaceId} />
      </Card>
    </div>
  );
}
